// import node module libraries
import React, { Fragment, useEffect, useState } from 'react';
import { Card, Col, Form, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { ChevronLeft, ChevronRight } from 'react-feather';
import ReactPaginate from 'react-paginate';

// import utility file
import { Avatar } from '../../../elements/bootstrap/Avatar';
import ParentService from '../../services/ParentService';

// import utility file

const ParentsGridCard = () => {
	const [originalParents, setOriginalParents] = useState([]);
	const [parents, setParents] = useState([]);

	// Functions for display formatting
	const formatValue = (value, columnId) => {
		if (typeof value === 'string') {
			if (columnId === 'nom' && value) {
				return value.toUpperCase();
			} else if (columnId === 'relation' || columnId === 'adresse') {
				return (
					value && value.charAt(0).toUpperCase() + value.slice(1).toLowerCase()
				);
			} else {
				return value;
			}
		}
		return value;
	};

	const getInitials = (parent) => {
		const firstName = parent.prenom
			? parent.prenom.charAt(0).toUpperCase()
			: '';
		const lastName = parent.nom ? parent.nom.charAt(0).toUpperCase() : '';
		return `${lastName} ${firstName}`;
	};

	useEffect(() => {
		Promise.all([ParentService.getAllParents()]).then(([parentsData]) => {
			setOriginalParents(parentsData);
			setParents(parentsData);
		});
	}, []);

	// searching code started
	const [searchTerm, setSearchTerm] = useState('');

	const getSearchTerm = (event) => {
		let searchTerm = event.target.value;
		setSearchTerm(searchTerm);
		if (searchTerm !== '') {
			const newParentsList = originalParents.filter((parent) => {
				let parentData =
					`${parent.nom} ${parent.prenom} ${parent.relation} ${parent.adresse} ${parent.telephone}`.toLowerCase();
				return parentData.includes(searchTerm.toLowerCase());
			});
			setParents(newParentsList);
			setPageNumber(0);
		} else {
			setParents(originalParents);
		}
	};

	const parentsEleve = parents.map((parent) => ({
		...parent
	}));

	// paging start
	const [pageNumber, setPageNumber] = useState(0);
	const parentsPerPage = 8;
	const pagesVisited = pageNumber * parentsPerPage;
	const pageCount = Math.ceil(parentsEleve.length / parentsPerPage);
	const changePage = ({ selected }) => {
		setPageNumber(selected);
	};

	const displayParents = parentsEleve
		.slice(pagesVisited, pagesVisited + parentsPerPage)
		.map((parent) => {
			const initials = getInitials(parent);
			return (
				<Col xl={3} lg={6} md={6} sm={12} key={parent.id}>
					<Card className="mb-5">
						<Card.Body>
							<div className="text-center">
								<div className="position-relative mb-2">
									<Link to={`/education/parents/${parent.id}`}>
										<Avatar
											type="initial"
											size="xl"
											name={initials}
											className="rounded-circle"
											alt={initials}
										/>
									</Link>
								</div>
								<Link to={`/education/parents/${parent.id}`}>
									<h4 className="mb-0">{formatValue(parent.nom, 'nom')}</h4>
								</Link>
							</div>
							<div className="d-flex justify-content-between border-bottom py-2 mt-6">
								<span>Relation</span>
								<span className="text-dark">
									{formatValue(parent.relation, 'relation')}
								</span>
							</div>
							<div className="d-flex justify-content-between border-bottom py-2">
								<span>Téléphone</span>
								<span>{parent.telephone}</span>
							</div>
							<div className="d-flex justify-content-between pt-2">
								<span>Adresse</span>
								<span className="text-dark">
									{formatValue(parent.adresse, 'adresse')}
								</span>
							</div>
						</Card.Body>
					</Card>
				</Col>
			);
		});
	// end of paging

	return (
		<Fragment>
			<div className="mb-4">
				<Row className="justify-content-md-between mb-4 mb-xl-0 ">
					<Col xl={2} lg={4} md={6} xs={12}>
						{/* search records */}
						<div className="mb-2 mb-lg-4">
							<Form.Control
								type="search"
								placeholder="Rechercher un parent"
								value={searchTerm}
								onChange={getSearchTerm}
							/>
						</div>
					</Col>
				</Row>
			</div>
			<Row>
				{displayParents.length > 0 ? (
					displayParents
				) : (
					<Col>Aucun parent correspondant n'a été trouvé.</Col>
				)}
			</Row>
			<ReactPaginate
				previousLabel={<ChevronLeft size="14px" />}
				nextLabel={<ChevronRight size="14px" />}
				pageCount={pageCount}
				onPageChange={changePage}
				containerClassName={'justify-content-center mb-0 pagination'}
				previousLinkClassName={'page-link mx-1 rounded'}
				nextLinkClassName={'page-link mx-1 rounded'}
				pageClassName={'page-item'}
				pageLinkClassName={'page-link mx-1 rounded'}
				disabledClassName={'paginationDisabled'}
				activeClassName={'active'}
			/>
		</Fragment>
	);
};

export default ParentsGridCard;
